import React from 'react';
import styled from 'styled-components';
import { ClientDetail } from '../../types/adminPortalApiSchema';
import { Heading2 } from '../Theme/Theme';
import CommunityActivitySection from './CommunityActivitySection';
import CommunityFriendUrlSection from './CommunityFriendUrlSection';

export type FollowMutation = 'follow' | 'unfollow';

export type FollowAction = {
  title: string;
  instructions: string;
  followeeUserIds?: string[];
  followerUserIds?: string[];
  mutation: FollowMutation;
};

type Props = {
  userId: ClientDetail['id'];
};

const CommunitySection: React.FC<Props> = ({ userId }) => {
  return (
    <CommunitySectionWrapper>
      <Heading2>Community</Heading2>
      <SectionWrapper>
        <CommunityActivitySection userId={userId} />
      </SectionWrapper>
      <SectionWrapper>
        <CommunityFriendUrlSection userId={userId} />
      </SectionWrapper>
    </CommunitySectionWrapper>
  );
};

export default CommunitySection;

const CommunitySectionWrapper = styled.div`
  padding: 50px;
`;

const SectionWrapper = styled.div`
  gap: 40px;
  width: 100%;
  display: flex;
  justify-content: space-between;
`;
